import _slicedToArray from "/vercel/16327899/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import "core-js/modules/es6.array.index-of";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.object.assign";

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

import { CheckIcon, InfoIcon, WarningIcon } from "./alert-icons";
import { chakra, useThemeDefaultProps } from "@chakra-ui/system";
import { createContext, cx } from "@chakra-ui/utils";
import * as React from "react";
export var ALERT_STATUSES = {
  info: {
    icon: InfoIcon,
    colorScheme: "blue"
  },
  warning: {
    icon: WarningIcon,
    colorScheme: "orange"
  },
  success: {
    icon: CheckIcon,
    colorScheme: "green"
  },
  error: {
    icon: WarningIcon,
    colorScheme: "red"
  }
};

var _createContext = createContext({
  name: "AlertContext"
}),
    _createContext2 = _slicedToArray(_createContext, 2),
    AlertContextProvider = _createContext2[0],
    useAlertContext = _createContext2[1];

var StyledAlert = chakra("div", {
  themeKey: "Alert.Root",
  baseStyle: {
    width: "100%",
    display: "flex",
    alignItems: "center",
    position: "relative",
    overflow: "hidden"
  },
  attrs: {
    role: "alert"
  }
});
/**
 * Alert
 *
 * React component used to communicate the state or status of a
 * page, feature or action
 */

export var Alert = /*#__PURE__*/React.forwardRef(function Alert(props, ref) {
  var defaults = useThemeDefaultProps("Alert");

  var _props$status = props.status,
      status = _props$status === void 0 ? "info" : _props$status,
      _props$variant = props.variant,
      variant = _props$variant === void 0 ? defaults == null ? void 0 : defaults.variant : _props$variant,
      className = props.className,
      rest = _objectWithoutPropertiesLoose(props, ["status", "variant", "className"]);

  var colorScheme = ALERT_STATUSES[status].colorScheme;
  var context = {
    status: status,
    variant: variant
  };

  var _className = cx("chakra-alert", className);

  return /*#__PURE__*/React.createElement(AlertContextProvider, {
    value: context
  }, /*#__PURE__*/React.createElement(StyledAlert, _extends({
    ref: ref,
    variant: variant,
    colorScheme: colorScheme,
    className: _className
  }, rest)));
});
export var AlertTitle = chakra("div", {
  themeKey: "Alert.Title",
  baseStyle: {
    fontWeight: "bold",
    lineHeight: "normal"
  },
  attrs: function attrs(props) {
    return {
      className: cx("chakra-alert__title", props.className)
    };
  }
});
/**
 * AlertDescription
 *
 * The description of the alert to be announced by screen
 * readers.
 */

export var AlertDescription = chakra("div", {
  themeKey: "Alert.Description",
  baseStyle: {
    display: "inline-block"
  },
  attrs: function attrs(props) {
    return {
      className: cx("chakra-alert__description", props.className)
    };
  }
});
var StyledWrapper = chakra("span", {
  themeKey: "Alert.Icon"
});
/**
 * AlertIcon
 *
 * The visual icon for the alert that changes based on the `status` prop.
 */

export var AlertIcon = function AlertIcon(props) {
  var _useAlertContext = useAlertContext(),
      status = _useAlertContext.status,
      variant = _useAlertContext.variant;

  var _ALERT_STATUSES$statu = ALERT_STATUSES[status],
      icon = _ALERT_STATUSES$statu.icon,
      colorScheme = _ALERT_STATUSES$statu.colorScheme;
  var Icon = icon;

  var _className = cx("chakra-alert__icon");

  return /*#__PURE__*/React.createElement(StyledWrapper, _extends({
    display: "inherit",
    variant: variant,
    colorScheme: colorScheme
  }, props, {
    className: _className
  }), /*#__PURE__*/React.createElement(Icon, {
    boxSize: "100%"
  }));
};